import { render, staticRenderFns } from "./GameBuilderTopicStep.vue?vue&type=template&id=124635d9&"
import script from "./GameBuilderTopicStep.vue?vue&type=script&lang=js&"
export * from "./GameBuilderTopicStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports